import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';

import userActions from '../../context/users/actions';
import rolesActions from '../../context/roles/actions'
import { ToastContainer, notify } from '../../libraries/notifications';
import { validateIsfilled } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextWithIconInput from '../../components/forms/TextWithIconInput';

class PasswordChange extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      role: '',
      submitting: false,
      showPassword: false,
      showNewPassword: false,
      showNewPassword2: false,
      user: null
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser = async () => {
    await this.props.onGetUser({ id: this.props.auth.user.id });
    const error = this.props.user.error;
    if (error) {
      notify(this.t(error.message));
    } else {
      this.setState({ user: this.props.user.item }, () => this.getRole(this.props.auth.user.roles[0]));
    }
  };

  getRole = async role => {
    await this.props.onGetRoles({ code: role });
    const { roles } = this.props;
    if (roles.error) {
      notify(this.t(roles.error.message));
    } else {
      this.setState({ role: roles.items[0].id });
    }
  };

  onSubmit = async values => {
    const user = this.state.user;
    this.setState({ submitting: true });
    await this.props.onUpdate({
      password: values.password,
      newpassword: values.newpassword,
      id: user.id,
      user_type: this.props.auth.user.type[0],
    });
    if (this.props.user.error) {
      this.setState({ submitting: false });
      notify(this.t(this.props.user.error.message));
    } else {
      history.push(config.ROUTES.USER.PROFILE);
    }
  };

  onPasswordClick = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  onNewPasswordClick = () => {
    this.setState({ showNewPassword: !this.state.showNewPassword });
  };

  onNewPasswordClick2 = () => {
    this.setState({ showNewPassword2: !this.state.showNewPassword2 });
  };

  render() {
    const required = value => (validateIsfilled(value) ? undefined : this.t('This field is required'));
    const validate = values => {
      let errors = [];
      if (values.newpassword !== values.newpassword2) errors.newpassword2 = this.t('Passwords must match');
      return errors;
    };
    return (
      <LayoutSmall
        main={{ className: 'bg-base-200 text-primary bg-pattern' }}
        header={{
          title: this.t('Change password'),
          className: 'bg-transparent text-primary',
          left: { icon: 'arrow_left', action: () => history.push(config.ROUTES.USER.PROFILE) }
        }}
        container={{
          className: 'mt-10'
        }}
        loading={this.props.user.loading}>
        <ToastContainer />
        <section className="px-4 mt-5">
          <Form onSubmit={this.onSubmit} validate={validate}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                <div className="py-3">
                  <div className="w-full px-3 mb-3 md:mb-0">
                    <Field
                      name="password"
                      component={TextWithIconInput}
                      placeholder={this.t('Password')}
                      label={this.t('Current password')}
                      className="text-gray-700"
                      showPassword={this.state.showPassword}
                      clickPassword={this.onPasswordClick}
                      validate={required}
                    />
                  </div>
                  <div className="w-full px-3 mb-3 md:mb-0">
                    <Field
                      name="newpassword"
                      component={TextWithIconInput}
                      placeholder={this.t('New password')}
                      label={this.t('New password')}
                      className="text-gray-700"
                      showPassword={this.state.showNewPassword}
                      clickPassword={this.onNewPasswordClick}
                      validate={required}
                    />
                  </div>
                  <div className="w-full px-3 mb-10 md:mb-0">
                    <Field
                      name="newpassword2"
                      component={TextWithIconInput}
                      placeholder={this.t('Repite new password')}
                      className="text-gray-700"
                      showPassword={this.state.showNewPassword2}
                      clickPassword={this.onNewPasswordClick2}
                      validate={required}
                    />
                  </div>
                  <div className="w-full px-3">
                    <Button
                      className="btn btn-lg btn-block btn-primary"
                      title={this.t('Confirm')}
                      onClick={handleSubmit}
                      disabled={this.state.submitting}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>
        </section>
      </LayoutSmall>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    roles: state.roles.list,
    user: state.users.current
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdate: values => dispatch(userActions.saveOrUpdate(values, 'update')),
    onGetRoles: params => dispatch(rolesActions.getAll(params)),
    onGetUser: params => dispatch(userActions.get(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PasswordChange));
